import { Layout, Table, Typography, Col } from "antd";
import React, { forwardRef, useImperativeHandle, useMemo, useState } from "react";
import DpatSubIndicatorSection from "../setup/DpatSubIndicatorSection";
import DpatIndicatorCmsIntro from "../setup/DpatIndicatorCmsIntro";
import MaxScoreDisplay from "../setup/MaxScoreDisplay";
import ActualScoreDisplay from "../setup/ActualScoreDisplay";
import IndicatorScoreSection from "../setup/IndicatorScoreSection";
import Comment from "components/Comments";
import { transformDpatTableRows } from "utils/renderDpatEvidenceLink";

const AuditCommitteeResponsiveness = forwardRef(({ 
    year,
    audits,
    actions,
    managementLetters,
    hideComment,
    districtId,
    savedAssessmentData,
    isAssessmentStarted,
}, ref) => {

    const { Header, Content } = Layout;
    const { Title, Text } = Typography;
    const [maxScore, setMaxScore] = useState(3);

    const resolvedAudits = useMemo(() => {
        if (!isAssessmentStarted || !savedAssessmentData) return audits;
        return savedAssessmentData.audits ?? audits;
    }, [isAssessmentStarted, savedAssessmentData, audits]);

    useImperativeHandle(ref, () => ({
        getData: () => ({
            indicator: "PI3",
            area: "Audit Performance",
            score: resolvedAudits?.score || 0, 
            maxScore,
            audits: resolvedAudits,
        }),
    }));

    const DPAT_SLUG = "pi3.0-3.1";

    const MEETING_LINK_KEYS = ["docs"];

    const auditReportColumns = [
        { title: "Qtr", dataIndex: "meeting", key: "meeting" },
        { title: "Date of Audit Committee Meeting", dataIndex: "meetingDate", key: "meetingDate" },
        { title: "No. of recommendations in audit reports", dataIndex: "recommendationsNo", key: "recommendationsNo" },
        { title: "No. of actions taken by Management", dataIndex: "actions", key: "actions" },
        { title: "Minute Link", dataIndex: "docs", key: "docs" },
    ];

    const recommendationActionColumns = [
        { title: "Quarters", dataIndex: "quarter", key: "quarter" },
        { title: "Recommendations in audit reports", dataIndex: "recommendations", key: "recommendations" },
        { title: "AC’s Comments /Recommendation", dataIndex: "comments", key: "comments" }
    ];

    const managementLettersColumns = [
        { title: "Date & ref. No. of Date Mgt. Letter(s)", dataIndex: "date", key: "date" },
        { title: "Date of Audit Committee Meeting", dataIndex: "meetingDate", key: "meetingDate" },
        { title: "No. of recommendations in audit reports", dataIndex: "noRecommendation", key: "noRecommendation" },
        { title: "No. of actions taken by Management", dataIndex: "noactionTaken", key: "noactionTaken" },
        { title: "No. of Audit Committee Comments", dataIndex: "auditComments", key: "auditComments" }
    ];

    return (
        <Comment
            data={resolvedAudits?.data}
            year={year}
            districtId={districtId}
            tableCommentedId={`pi3.0-3.1-${year}`}
            hideComment={hideComment}
        >
            {({ renderCommentFeedbackFooter }) => (
          <DpatSubIndicatorSection code={DPAT_SLUG}>
                    <DpatIndicatorCmsIntro
                        year={year}
                        slug={DPAT_SLUG}
                        mainTitleStyle={{ marginTop: "20px" }}
                    />

                    <IndicatorScoreSection>
                      <MaxScoreDisplay score={maxScore} />
                      <ActualScoreDisplay slug={DPAT_SLUG} label="PI 3.0-3.1 Actual Score" score={resolvedAudits?.score || 0} />
                    </IndicatorScoreSection>

                    <Title level={5} style={{ marginTop: "20px" }}>
                        Audit Observations in Quarterly Internal Audit Reports
                    </Title>
                    <Table
                        columns={auditReportColumns}
                        dataSource={transformDpatTableRows(resolvedAudits?.data || [], MEETING_LINK_KEYS)}
                        pagination={false}
                        bordered
                    />

                    {/* Data not available in DDDP at the moment */}

                    {/* <Title level={5} style={{ marginTop: "20px" }}>
                        Recommendations and Actions Taken
                    </Title>
                    <Table
                        columns={recommendationActionColumns}
                        dataSource={actions || []}
                        pagination={false}
                        bordered
                    />

                    <Title level={5} style={{ marginTop: "20px" }}>
                        Management Letters on the external audit
                    </Title>
                    <Table
                        columns={managementLettersColumns}
                        dataSource={managementLetters || []}
                        pagination={false}
                        bordered
                    /> */}
            {!hideComment && renderCommentFeedbackFooter()}
          </DpatSubIndicatorSection>
            )}
        </Comment>
    );
})

export default AuditCommitteeResponsiveness;